import Bricks from './Bricks';
import BricksItem from './BricksItem';

Bricks.Item = BricksItem;

export default Bricks;
